export default {
    ROOT: '/'
}